<div class="w-100 mx-auto" mx-auto>
  <form [formGroup]="stepFormGroup" class="step-container">
    <mat-card class="card-general">
      <mat-card-title>Realizar Setup en:</mat-card-title>
      <mat-card-content>
        <div class="container">
          <mat-radio-group aria-label="Seleciona una opción" formControlName="setupType" class="row" required >
            <mat-radio-button  class="col-12 col-md-4 col-lg-4 gy-3" *ngFor="let item of setupOptions" [value]="item.value" [checked]="item.value == getControl(stepFormGroup, 'setupType')" (change)="onChangeOption($event)"><span style="white-space:normal">{{item.display}}</span></mat-radio-button>
          </mat-radio-group>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <div class="text-end">
        <button mat-button matStepperNext data-testid="nextStep1" class="button secondary-button" (click)="updateStepPrescription()" [disabled]="disabledButtonStages()">Guardar y Continuar <mat-icon>chevron_right</mat-icon></button>
      </div>
    </div>
  </form>
</div>
